export const apolloConfig = {
  networkInterface: process.env.APOLLO_API_URL
}

export default apolloConfig